import { render, staticRenderFns } from "./UserCustomization.vue?vue&type=template&id=53088112&"
import script from "./UserCustomization.vue?vue&type=script&lang=js&"
export * from "./UserCustomization.vue?vue&type=script&lang=js&"
import style0 from "./UserCustomization.vue?vue&type=style&index=0&id=53088112&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports